export const MEDIA_ARTICLE_CATEGORY_COLORS: Record<string, string> = {
    'Markets & Economy': 'var(--nw-navy-500)',
    'Retirement Planning': 'var(--nw-purple-500)',
    'Financial Planning': 'var(--nw-pink-500)',
    'Company News': 'var(--nw-teal-500)'
};

export const MEDIA_ARTICLE_CATEGORIES = Object.keys(MEDIA_ARTICLE_CATEGORY_COLORS);
